import React, {PureComponent} from 'react';

import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import * as modalActions from '@/actions/modalActions';
import * as setupActions from '@/actions/setupActions';
import * as updateSystemAction from '@/actions/updateSystemAction';
import BackIconDisabled from '@/assets/icons/custom-back-disabled.svg';
import BackIcon from '@/assets/icons/custom-back.svg';
import DownloadIcon from '@/assets/icons/Download.svg';
import {activeLicenseActivationModal} from '@/businesses/licenseBusiness';
import Button from '@/components/button/Button';
import DoubleButton from '@/components/doubleButton/DoubleButton';
import * as APPDATA from '@/constants/pcConstAppData';
import * as PC_COMMON_FUNCTION from '@/libs/appHelper';
import {newLineHtml} from '@/libs/htmlHelper';

import './topMenu.less';

const EXPAND = 'EXPAND';
const COLLAPSE = 'COLLAPSE';

@connect((store) => ({
  activeMenu: store.setupStore.activeMenu,
  profileName: store.setupStore.profileName,
  profileList: store.setupStore.profileList,
  topButtonProperties: store.setupStore.topButtonProperties,
  topButtonSecondaryButtonProperties: store.setupStore.topButtonSecondaryButtonProperties,
  topButtonTertiaryButtonProperties: store.setupStore.topButtonTertiaryButtonProperties,
  backButtonProperties: store.setupStore.backButtonProperties,
  titleMenuProperties: store.setupStore.titleMenuProperties,
  isManualProfileRunning: store.setupStore.isManualProfileRunning,
  profileRunning: store.setupStore.profileRunning,
  isPCRunning: store.setupStore.isPCRunning,
  expandAccordionStatus: store.setupStore.expandAccordionStatus,
  isDoubleButton: store.setupStore.isDoubleButton,
  isShowTopButton: store.setupStore.isShowTopButton,
  isSecondaryButton: store.setupStore.isSecondaryButton,
  isTertiaryButton: store.setupStore.isTertiaryButton,
  isShowActiveMenu: store.setupStore.isShowActiveMenu,
  button1Properties: store.setupStore.button1Properties,
  button2Properties: store.setupStore.button2Properties,
  licenseStatus: store.deviceInfoStore.licenseStatus,
  licenseType: store.deviceInfoStore.licenseType,
  isMinimizeUpdate: store.updateSystemStore.IsMinimizeUpdate,
  downloadBinaryStatus: store.updateSystemStore.StatusDonloadBinaryUpdate,
}))
class TopMenu extends PureComponent {
  constructor(props) {
    super(props);
    // Initiate state for this component
    this.state = {
      showTopBarList: [
        APPDATA.ADVANCED_SETTINGS,
        APPDATA.EXPLORER,
        APPDATA.INFO_AND_SUPPORT,
        APPDATA.SETUP,
        APPDATA.STATUS,
        APPDATA.MORE_SETUP,
        APPDATA.SEARCH_RESULT,
        APPDATA.CYCLE_THRESHOLD,
        APPDATA.DEVICE_SETTING,
        // APPDATA.DISPLAY_SETTING,
        APPDATA.GENERAL_SETTING,
        APPDATA.PRESSURE_SETTING,
        // APPDATA.VOLUME_THRESHOLD_SETTING,
        APPDATA.WIFI_SETTING,
        APPDATA.CYCLE_HISTORY,
        APPDATA.SYSTEM_LOG,
        APPDATA.SELECT_FILE,
        APPDATA.SELECT_FOLDER,
        APPDATA.SELECT_FOLDER_SYSTEM_LOG,
        APPDATA.CLEANING_WIZARD,
        // APPDATA.CALIBRATION_VOLUME_SENSOR,
        APPDATA.CALIBRATION_LOAD_CELL_SENSOR,
        APPDATA.CALIBRATION_LOAD_CELL_CHECK_SCALE,
        APPDATA.CALIBRATION_LOAD_CELL_CALIBRATE_SCALE,
        APPDATA.CALIBRATION_HISTORY,
        APPDATA.RELEASE_NOTES,
        APPDATA.MANUAL_PROFILE,
        APPDATA.MANUAL_PROFILE_EXPLORER,
        APPDATA.ADVANCED_SETUP_NEW,
        APPDATA.ADVANCED_SETUP_EXPLORER,
        APPDATA.VOLUME_SENSOR_CHART,
        APPDATA.SETUP,
        APPDATA.STATUS,
        APPDATA.AUTO_PROFILE_SETUP_TAB,
        APPDATA.AUTO_PROFILE_STATUS_TAB,
        APPDATA.AUTO_PROFILE_PARAMETERS_TAB,
        APPDATA.ADVANCED_SETUP_NEW,
      ],
    };
    this.onClick = this.onClick.bind(this);
  }

  onClick(e) {
    const {profileList, activeMenu, backButtonProperties, dispatch} = this.props;
    const {id} = e.currentTarget;

    switch (id) {
      case APPDATA.BACK:
        // TODO : Refactor action back using topMenuProperties redux !!
        switch (activeMenu) {
          case APPDATA.SEARCH_RESULT: {
            const lastProfileIdView =
              // eslint-disable-next-line no-nested-ternary
              profileList === null
                ? APPDATA.MAX_PROFILE_VIEW
                : profileList.length < APPDATA.MAX_PROFILE_VIEW
                ? profileList.length
                : APPDATA.MAX_PROFILE_VIEW;
            dispatch(setupActions.setLastProfileIdView(lastProfileIdView));
            // this.props.dispatch(setupActions.updateActiveMenu(APPDATA.EXPLORER))
            dispatch(setupActions.updateActiveMenu(APPDATA.ADVANCED_SETUP_EXPLORER));
            // to show all profilist, need update props showProfile with updateProfileList
            dispatch(setupActions.updateAdvSetupList(true));
            break;
          }
          case APPDATA.SELECT_FILE:
            window.location.href = APPDATA.INFO_AND_SUPPORT_ADDRESS;
            break;
          case APPDATA.SELECT_FOLDER:
            window.location.href = APPDATA.CYCLE_HISTORY_ADDRESS;
            break;
          case APPDATA.SELECT_FOLDER_SYSTEM_LOG:
            window.location.href = APPDATA.SYSTEM_LOGS_ADDRESS;
            backButtonProperties.onClick(e);

            break;
          // system logs
          case APPDATA.CYCLE_HISTORY:
            // window.location.href = APPDATA.SYSTEM_LOGS_ADDRESS;
            backButtonProperties.onClick(e);
            break;
          // TODO : refactor this for not depend with topMenu
          // case APPDATA.CALIBRATION_VOLUME_SENSOR:
          case APPDATA.CLEANING_WIZARD:
          case APPDATA.CALIBRATION_LOAD_CELL_SENSOR:
          case APPDATA.CALIBRATION_LOAD_CELL_CHECK_SCALE:
          case APPDATA.CALIBRATION_LOAD_CELL_CALIBRATE_SCALE:
          case APPDATA.CALIBRATION_HISTORY:
          case APPDATA.RELEASE_NOTES:
          case APPDATA.MORE_SETUP:
          case APPDATA.SETUP:
          case APPDATA.EXPLORER:
          case APPDATA.ADVANCED_SETUP_EXPLORER:
          case APPDATA.MANUAL_PROFILE:
          case APPDATA.AUTO_PROFILE_SETUP_TAB:
          case APPDATA.VOLUME_SENSOR_CHART:
          case APPDATA.AUTO_PROFILE_STATUS_TAB:
          case APPDATA.AUTO_PROFILE_PARAMETERS_TAB:
          case APPDATA.ADVANCED_SETUP_NEW:
          case APPDATA.CYCLE_THRESHOLD:
          case APPDATA.DEVICE_SETTING:
          case APPDATA.DISPLAY_SETTING:
          case APPDATA.PRESSURE_SETTING:
          case APPDATA.GENERAL_SETTING:
          case APPDATA.MANUAL_PROFILE_EXPLORER:
            // case APPDATA.SYSTEM_LOG:
            // case APPDATA.VOLUME_THRESHOLD_SETTING:
            backButtonProperties.onClick(e);
            break;
          default:
            window.location.href = APPDATA.HOME_SCREEN_ADDRESS;
        }
        break;
      case EXPAND:
        dispatch(setupActions.expandAccordionStatus(true));
        break;
      case COLLAPSE:
        dispatch(setupActions.expandAccordionStatus(false));
        break;

      default:
        break;
    }
  }

  onClickDemoButton = () => {
    const {isPCRunning, isManualProfileRunning, dispatch} = this.props;
    // ConsoleLog("Demo Button Clicked ");
    if (isPCRunning || isManualProfileRunning) {
      dispatch(
        setupActions.showAlert({
          alertShow: true,
          alertText: APPDATA.MESSAGES.LICENSE.ALLERT.DEMO,
          alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_WARNING,
        }),
      );
    } else {
      const popUpButton = [
        {
          id: APPDATA.ACTIVATE,
          label: APPDATA.ACTIVATE,
          isPrimaryButton: true,
          onClick: this.onClickButtonDemoModal,
        },
      ];
      dispatch(
        modalActions.showPopUp({
          popUpTitle: APPDATA.MESSAGES.LICENSE.MODAL_DEMO.TITLE,
          popUpText: newLineHtml(APPDATA.MESSAGES.LICENSE.MODAL_DEMO.TEXT),
          popUpButton,
          popUpHideCloseButton: true,
        }),
      );
    }
  };

  onClickMinimizeUpdateButton = () => {
    const {dispatch} = this.props;
    dispatch(updateSystemAction.isMinimizeUpdate(false));
  };

  onClickButtonDemoModal = (e) => {
    const {dispatch} = this.props;
    switch (e.currentTarget.id) {
      case APPDATA.ACTIVATE:
        dispatch(activeLicenseActivationModal());
        break;
      case APPDATA.CANCEL:
      default:
        dispatch(modalActions.hidePopUp());
        break;
    }
  };

  generateSecondaryTopButtonProps = () => {
    const {topButtonSecondaryButtonProperties} = this.props;
    if (topButtonSecondaryButtonProperties === undefined) return undefined;

    const buttonProps = {
      id: topButtonSecondaryButtonProperties.id,
      onClick: topButtonSecondaryButtonProperties.onClick,
      className: topButtonSecondaryButtonProperties.className,
      icon: topButtonSecondaryButtonProperties.icon,
      disabled: topButtonSecondaryButtonProperties.disabled,
    };
    return (
      <Button
        id={buttonProps.id}
        onClick={buttonProps.onClick}
        className={` secondaryButtonStyle ${buttonProps.className}`}
        icon={buttonProps.icon}
        disabled={buttonProps.disabled}
      />
    );
  };

  generateThirdTopButtonProps = () => {
    const {topButtonTertiaryButtonProperties} = this.props;
    if (topButtonTertiaryButtonProperties === undefined) return undefined;

    const thirdButtonProps = {
      id: topButtonTertiaryButtonProperties.id,
      onClick: topButtonTertiaryButtonProperties.onClick,
      className: topButtonTertiaryButtonProperties.className,
      icon: topButtonTertiaryButtonProperties.icon,
      disabled: topButtonTertiaryButtonProperties.disabled,
    };
    return (
      <Button
        id={thirdButtonProps.id}
        onClick={thirdButtonProps.onClick}
        className={` secondaryButtonStyle ${thirdButtonProps.className}`}
        icon={thirdButtonProps.icon}
        disabled={thirdButtonProps.disabled}
      />
    );
  };

  generateTopMenu() {
    const {
      activeMenu,
      isRemoteView,
      profileRunning,
      profileName,
      isPCRunning,
      mobileView,
      expandAccordionStatus,
      isDoubleButton,
      isShowTopButton,
      isSecondaryButton,
      isTertiaryButton,
      isShowActiveMenu,
      topButtonProperties,
      button1Properties,
      button2Properties,
      backButtonProperties,
      titleMenuProperties,
      licenseStatus,
      licenseType,
      isMinimizeUpdate,
      downloadBinaryStatus,
      isManualProfileRunning,
    } = this.props;
    const {showTopBarList} = this.state;

    const firstButton = {
      id: button1Properties.id,
      label: button1Properties.label,
      onClick: button1Properties.onClick,
      disabled: button1Properties.disabled,
      className: button1Properties.className !== undefined ? button1Properties.className : 'load-button',
      enableLongPress: button1Properties.enableLongPress,
      endLongPress: button1Properties.endLongPress,
      startLongPress: button1Properties.startLongPress,
    };
    const secondButton = {
      id: button2Properties.id,
      label: button2Properties.label,
      onClick: button2Properties.onClick,
      disabled: button2Properties.disabled,
      className: button2Properties.className !== undefined ? button2Properties.className : 'save-button',
    };

    const secondaryButtonProps = this.generateSecondaryTopButtonProps();
    const tertiaryButtonProps = this.generateThirdTopButtonProps();
    const singleTopButton = (
      <Button
        id={topButtonProperties.id}
        onClick={topButtonProperties.onClick}
        className={topButtonProperties.className ? `${topButtonProperties.className}saveButton` : 'saveButton'}
        disabled={topButtonProperties.disabled}
        label={topButtonProperties.label}
      />
    );
    const isProfileSetupPage = !!(activeMenu === APPDATA.SETUP || activeMenu === APPDATA.MORE_SETUP);
    const expandCollapseId = expandAccordionStatus ? COLLAPSE : EXPAND;
    const expandCollpaseIcon =
      expandCollapseId === EXPAND ? 'glyphicon glyphicon-menu-down' : 'glyphicon glyphicon-menu-up';

    const topMenuButton = isDoubleButton ? (
      <DoubleButton
        button1Props={firstButton}
        button2Props={secondButton}
      />
    ) : (
      singleTopButton
    );

    const isDemoMode = !(
      (licenseStatus === APPDATA.FIELD_NAME.LICENSE.STATUS.ACTIVE &&
        licenseType === APPDATA.FIELD_NAME.LICENSE.TYPE.TEMPORARY) ||
      licenseType === APPDATA.FIELD_NAME.LICENSE.TYPE.PERMANENT
    );

    if (PC_COMMON_FUNCTION.IsInArray(activeMenu, showTopBarList))
      return (
        <div className={isRemoteView === true ? 'remoteViewTopMenu' : 'topMenu'}>
          {backButtonProperties && (
            <div className="colBack no-padding">
              <Button
                id={APPDATA.BACK}
                onClick={this.onClick}
                className="backButton no-padding"
                icon={backButtonProperties.disabled ? BackIconDisabled : BackIcon}
                disabled={backButtonProperties.disabled}
              />
            </div>
          )}
          <div
            className="colTopMenuText no-padding"
            style={
              // eslint-disable-next-line no-nested-ternary
              activeMenu === APPDATA.ADVANCED_SETUP_NEW ||
              activeMenu === APPDATA.ADVANCED_SETUP_EXPLORER ||
              activeMenu === APPDATA.MANUAL_PROFILE_EXPLORER
                ? // eslint-disable-next-line no-nested-ternary
                  isDemoMode || isMinimizeUpdate
                  ? backButtonProperties
                    ? {maxWidth: '250px'}
                    : {maxWidth: '250px', paddingLeft: '20px'}
                  : backButtonProperties
                  ? {maxWidth: '350px'}
                  : {maxWidth: '350px', paddingLeft: '20px'}
                : backButtonProperties
                ? {maxWidth: '400px'}
                : {maxWidth: '400px', paddingLeft: '20px'}
            }
          >
            {isShowActiveMenu ? (
              <span className="topMenuText">{activeMenu.toUpperCase()}</span>
            ) : (
              <span className="topMenuText">{titleMenuProperties}</span>
            )}
            {isProfileSetupPage && <span className="topMenuText">{profileName}</span>}
            {!isRemoteView && activeMenu === APPDATA.STATUS && profileRunning !== null && isPCRunning && (
              <span className="topMenuText">&nbsp;-&nbsp;{profileRunning[APPDATA.KEY.Name]}</span>
            )}
          </div>
          {isDemoMode ? (
            <div className="colButton no-padding">
              <Button
                id="demoButton"
                onClick={this.onClickDemoButton}
                className="demoButton"
                // disabled={false}
                label={APPDATA.INACTIVE_LICENSE}
              />
            </div>
          ) : null}
          {isMinimizeUpdate && (
            <div className="colButton no-padding">
              <Button
                id="minimizeUpdateButton"
                onClick={this.onClickMinimizeUpdateButton}
                className="minimizeUpdateButton"
                disabled={isPCRunning || isManualProfileRunning}
                label={downloadBinaryStatus ? ` ${downloadBinaryStatus[APPDATA.KEY.DownloadProgress]} %` : ' 0 %'}
                icon={DownloadIcon}
              />
            </div>
          )}
          {isTertiaryButton ? <div className="colButton no-padding">{tertiaryButtonProps}</div> : null}
          {isSecondaryButton ? <div className="colButton no-padding">{secondaryButtonProps}</div> : null}
          {isShowTopButton ? <div className="colTopMenuButton no-padding">{topMenuButton}</div> : null}
          {mobileView && (
            <div className="col-xs-1 col-md-1 col-lg-1 colExpandCollapseButton no-padding">
              <button
                type="button"
                id={expandCollapseId}
                onClick={this.onClick}
                className={`${expandCollpaseIcon} button-collapse`}
              />
            </div>
          )}
        </div>
      );
    return null;
  }

  render() {
    return this.generateTopMenu();
  }
}

TopMenu.propTypes = {
  activeMenu: PropTypes.string,
  profileList: PropTypes.array,
  backButtonProperties: PropTypes.object,
  dispatch: PropTypes.func,
  isPCRunning: PropTypes.bool,
  isManualProfileRunning: PropTypes.bool,
  topButtonSecondaryButtonProperties: PropTypes.object,
  topButtonTertiaryButtonProperties: PropTypes.object,
  isRemoteView: PropTypes.bool,
  profileRunning: PropTypes.object,
  profileName: PropTypes.string,
  mobileView: PropTypes.bool,
  expandAccordionStatus: PropTypes.bool,
  isDoubleButton: PropTypes.bool,
  isShowTopButton: PropTypes.bool,
  isSecondaryButton: PropTypes.bool,
  isTertiaryButton: PropTypes.bool,
  isShowActiveMenu: PropTypes.bool,
  topButtonProperties: PropTypes.object,
  button1Properties: PropTypes.object,
  button2Properties: PropTypes.object,
  titleMenuProperties: PropTypes.string,
  licenseStatus: PropTypes.string,
  licenseType: PropTypes.string,
  isMinimizeUpdate: PropTypes.bool,
  downloadBinaryStatus: PropTypes.object,
};

TopMenu.defaultProps = {
  activeMenu: 'None',
  profileList: null,
  backButtonProperties: null,
  dispatch: () => {},
  isPCRunning: false,
  isManualProfileRunning: false,
  topButtonSecondaryButtonProperties: null,
  topButtonTertiaryButtonProperties: null,
  isRemoteView: false,
  profileRunning: null,
  profileName: null,
  mobileView: false,
  expandAccordionStatus: false,
  isDoubleButton: false,
  isShowTopButton: false,
  isSecondaryButton: false,
  isTertiaryButton: false,
  isShowActiveMenu: false,
  topButtonProperties: null,
  button1Properties: null,
  button2Properties: null,
  titleMenuProperties: null,
  licenseStatus: null,
  licenseType: null,
  isMinimizeUpdate: false,
  downloadBinaryStatus: null,
};

export default TopMenu;
